import { api } from '@/shared/axios-client';
import { queryOptions, useQuery } from '@tanstack/react-query';

export type CallGraphStats = {
  entityTypeCounts?: Record<string, number>;
  nodeCount?: number;
  edgeCount?: number;
  callsEdgeCount?: number;
  apiCallsEdgeCount?: number;
  containsEdgeCount?: number;
};

export type CallGraphEdge = {
  source: string;
  target: string;
  relation?: string;
  context?: string;
  confidence?: string;
  metadata?: {
    method?: string;
    path?: string;
  };
};

export type EntityMetadata = {
  rawFanout?: string[];
  resolvedFanout?: string[];
  resolvedFanouts?: string[];
  unresolvedFanout?: string[];
  fanIn?: string[];
  fanOut?: number;
  scores?: {
    fanIn?: number;
    fanOut?: number;
    leaf?: number;
    orphan?: number;
    total?: number;
  };
};

export type ScanCallableEntity = {
  entityKey?: string;
  entityId?:string;
  _id?:string;
  name?: string;
  type?: string;
  filePath?: string;
  lineStart?: number;
  lineEnd?: number;
  parentName?:string;
  parentEntityKey?:string;
  metadata?: EntityMetadata;
};

export type CallGraphApiResponse = {
  success: boolean;
  scanId: string;
  nodes: Array<Record<string, unknown>>;
  edges: CallGraphEdge[];
  entitiesByFile?: Record<string, ScanCallableEntity[]>;
  stats?: CallGraphStats;
  message?: string;
};

export const fetchCallGraph = (scanId: string): Promise<CallGraphApiResponse> =>
  api.post('/api/graph/call-graph', { scanId: scanId.trim() });

export const callGraphQueryOptions = (scanId: string, enabled = true) =>
  queryOptions({
    queryKey: ['call-graph', scanId],
    queryFn: () => fetchCallGraph(scanId),
    enabled: enabled && Boolean(scanId?.trim()),
  });

export const useCallGraph = (scanId: string, enabled = true) =>
  useQuery(callGraphQueryOptions(scanId, enabled));
